export default [{
  name: 'teclift',
  namespaced: true,
  state: {
    model: {
      Pessoa: {
        PF: {},
        PJ: {},
        TipoPessoa: null,
        PessoaDadosContato: {},
        PessoaDadoFinanceiro: {},
        PessoaEndereco: {},
        PessoaQualificacao: {},
      },
      Parcela: {},
      DadosIniciais: {}
    },
  },
  mutations: {
    model (state, obj) {
      state.model = obj
    },
  },
  getters: {
    model (state) {
      return state.model
    },
  },
  actions: {
    clearModel ({ commit }) {
      const data = {
        Pessoa: {
          PF: {},
          PJ: {},
          TipoPessoa: null,
          PessoaDadosContato: {},
          PessoaDadoFinanceiro: {},
          PessoaEndereco: {},
          PessoaQualificacao: {},
        },
        Parcela: {},
        DadosIniciais: {}
      }
      commit('model', data)
    }
  },
}]
